import { ChangeDetectionStrategy, Component, HostBinding, OnInit, ViewEncapsulation } from "@angular/core";
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from "@angular/material/legacy-dialog";
import { Store } from "@ngrx/store";
import { CORE_ROUTE, CoreState, RESPONSIBLE_GAMING_ROUTE } from "@obg/ngx.core";
import { CacheFactory, CacheStore, StorageMode } from "@obg/ngx.global";
import { RouteSelector } from "@obg/ngx.router";
import { Subscription } from "rxjs";
import { filter, take, tap } from "rxjs/operators";

import { CACHE_STORE_KEY, COVID_MESSAGE_SHOWN, CUSTOMER_VERIFICATION_DIALOG_ID } from "./covid-message.const";
@Component({
	selector: "obg-m-covid-message",
	templateUrl: "./covid-message.container.html",
	styleUrls: ["./covid-message.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class CovidMessageContainer implements OnInit {
	@HostBinding("class.obg-m-covid-message") hostCssClass = true;
	@HostBinding("attr.test-id") testId = "covid-message-dialog";

	readonly routeName = CORE_ROUTE.responsibleGaming.information;
	readonly cache: CacheStore;

	constructor(
		private matDialog: MatDialog,
		private store: Store<CoreState>,
		private dialogRef: MatDialogRef<any>,
		cacheFactory: CacheFactory
	) {
		this.cache = cacheFactory.get(CACHE_STORE_KEY, {
			storageMode: StorageMode.LocalStorage,
			maxAge: Number.MAX_VALUE,
		});
	}

	ngOnInit() {
		this.cache.setItem(COVID_MESSAGE_SHOWN, true);
	}

	closeDialog() {
		this.dialogRef.close();
	}

	goToResponsibleGaming(): Subscription {
		return this.store
			.pipe(RouteSelector.getName$)
			.pipe(
				filter((currentRoute) => currentRoute === RESPONSIBLE_GAMING_ROUTE.information),
				take(1),
				tap(() => {
					const openDialog = this.matDialog.openDialogs?.find(
						(d) => d.id === CUSTOMER_VERIFICATION_DIALOG_ID
					);
					openDialog?.close();
					this.closeDialog();
				})
			)
			.subscribe();
	}
}
